// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-3309b6a5] .itinerary .is-disabled * {\r\n  color: blue !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
